module.exports = __webpack_public_path__ + "img/receive-succeed.55db1764.png";